import React, { Component } from 'react'
import css from './styles.scss'

export class SampleFromReferenceEditor extends Component {
  constructor ({ variable, variableName, updateParent }) {
    super()
    this.state = {
      reference: variable.args[0] || '',
      sampleSize: variable.args[1] || 0,
      ignorePrevious: variable.args[2] || false
    }
  }

  handleUpdateReference = evt => {
    this.setState({
      reference: evt.target.value
    })
  }

  handleUpdateSampleSize = evt => {
    if (parseInt(evt.target.value, 10) > -1 || evt.target.value.length < 1) {
      this.setState({
        sampleSize: evt.target.value
      })
    }
  }

  handleUpdateIgnore = evt => {
    this.setState({
      ignorePrevious: evt.target.checked
    })
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    const { reference, sampleSize, ignorePrevious } = this.state
    if (nextProps.report === true && report === false) {
      save(variableName, [reference, sampleSize, ignorePrevious])
    }
  }

  render () {
    const { referenceVariables } = this.props
    const { reference, sampleSize, ignorePrevious } = this.state
    const references = referenceVariables.map(variable => (
      <option value={variable} key={variable}>{variable}</option>
    ))
    references.unshift(<option value='' key='EMPTY_OPTION'>Choose...</option>)

    return (
      <div>
        <label>
          Reference
          <div className={css.backer}>
            <select
              className={css.select}
              value={reference}
              onChange={this.handleUpdateReference}
            >
              {references}
            </select>
          </div>
        </label>
        <label className={css.label}>
          Sample Size
          <input
            className={css.option}
            type='number'
            value={sampleSize}
            onChange={this.handleUpdateSampleSize}
          />
        </label>
        <label className={css.label}>
          <input
            type='checkbox'
            checked={ignorePrevious}
            onChange={this.handleUpdateIgnore}
          /> Ignore previous selections
        </label>
      </div>
    )
  }
}
export default SampleFromReferenceEditor



// WEBPACK FOOTER //
// /app/js/components/EditVariable/SampleFromReferenceEditor/index.js